import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AddIcon from "@material-ui/icons/Add";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _SearchResultTable } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";
import { GetAccountBalanceListColumns } from "../components/SearchTableColumns/AccountBalanceListColumns";
import useTable from "../hooks/Table";

export const _AccountBalanceList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_EstrattoConto: "", Data: "", ID_TipoEstrattoContoStato: "", ID_AnagDa: "", ID_AnagA: "" });
    const { Data, Options, IsLoading } = useTable("/api/EstrattoConto/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("EstrattoContoController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={AccountBalanceWalletIcon} Title="EstrattoConto">
                    {Glob.AzioneAbilitata("EstrattoContoController", Glob.Scrittura) && (
                        <a href="/EstrattoContoQuietanze">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_EstrattoConto"
                                    label={Trad.Trad("EstrattoConto")}
                                    value={FormData.ID_EstrattoConto}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField Value={FormData.Data} Name="Data" Label="Data" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Select
                                    Value={FormData.ID_TipoEstrattoContoStato}
                                    Name="ID_TipoEstrattoContoStato"
                                    Label="Stato"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["EstrattoContoStato"]) || {}}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={FormData.ID_AnagDa}
                                    Name="ID_AnagDa"
                                    Label="Da"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={FormData.ID_AnagA}
                                    Name="ID_AnagA"
                                    Label="A"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_SearchResultTable Data={Data} Columns={GetAccountBalanceListColumns(Data?.Tipi["EstrattoContoStato"])} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/AccountBalanceList.tsx